<script setup>
import {useAuthStore} from '~/store/auth'
import {useNotification} from '~/composables/useNotification'
import BreadCrumb from '~/components/common/BreadCrumb.vue'
import PricingTableLoginForm from '~/components/forms/users/PricingTableLoginForm.vue'
import {useSEOData} from '~/composables/useSEOData'

const config = useRuntimeConfig()
const breadcrumbs = ref([
  {label: 'Inicio', link: '/'},
  {label: 'Acceso Tarifario', link: '/tarifario'}
])

definePageMeta({
  middleware: 'only-not-price-table-authenticated'
})

useSEOData('pricing-table-login')

const router = useRouter()
const route = useRoute()
const notification = useNotification()
const authStore = useAuthStore()
const redirectTo = ref('/tarifario')

async function onLoginSuccess() {
  try {
    await router.push(redirectTo.value)
  } catch (e) {
  }
}

onBeforeMount(() => {
  if (route.query?.redirectTo) redirectTo.value = route.query.redirectTo
})
</script>

<template>
  <div class="grid grid-cols-12 bg-[#fcfbfa]">
    <div class="col-span-12 mb-5">
      <h1 class="mt-5 text-2xl font-bold italic px-4 xl:px-8 underline">Acceso Tarifas para Profesionales</h1>
      <BreadCrumb class="px-4 lg:px-8" :items="breadcrumbs"/>
    </div>

    <div class="col-span-12 offset xl:col-span-6 xl:col-start-4 text-center xl:text-start border-b">
      <h2 class="text-lg font-bold italic mb-3">Contraseña de acceso</h2>
    </div>

    <PricingTableLoginForm
      class="col-span-12 offset xl:col-span-6 xl:col-start-4 mt-5 mb-10"
      @login-success="onLoginSuccess"
      autofocus
    />
  </div>
</template>

